import { useEffect, useRef } from 'react';

export function useSetInterval(fn: () => void, interval: number) {
  const intervalId = useRef<NodeJS.Timeout>();

  useEffect(() => {
    intervalId.current = setInterval(fn, interval);

    return () => {
      if (intervalId.current) {
        clearTimeout(intervalId.current);
      }
    };
  }, [fn, interval]);
}
